
import { Card, CardContent, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import dayjs from '../../utils/dayjs-setup';
import { useState,useEffect, useContext } from "react";
import { DatePickerInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DateFormatString,  FormActions, FormatPrice, usuarioEntity } from "../../utils/constants";
import * as yup from "yup";
import { FilterForm } from "../../components/form/filter-form";




const CardResumeBuild = ({
  title="",
  label_numer="",
  extraLabel=""
})=>(
  <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h5" component="div">
          {label_numer}
        </Typography>
       <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {extraLabel}
        </Typography> 
      
      </CardContent>
{/*       <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
)

const schema = yup.object({
  cod_usuario: yup.string().required(),

  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional()
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  month:dayjs().startOf("month"),
};

const schemaFilter = yup.object({
  

}).required();

export const AgentesComprasProveedorList = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productFilterList,setProductFilterList] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [totalPage,setTotalCompras] = useState({
    "valor_total_comprado": 0,
    "cantidad_compras": 0,
    "compra_efectiva": 0,
    "valor_comision": 0,
  });


    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true,filterSearchPagination );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
     
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }


  const  setFilterAply = (filtros)=>{
    console.log({filtros});

    setFilterSearchPagination({
      ...filterSearchPagination,
      ...filtros
    });
  }

    const loadItems =  async (loading=true,filtros=filterSearchPagination)=>{
      console.log({filtros,filterSearchPagination});
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }
    
     let {data:{value}} = await AxiosInstance.post("maestros/listar-compras-proveedor",{
      ...filtros,
      producto:filtros.product_select?.value,
      month:dayjs(filtros.month).format(DateFormatString),
      page_number:filtros.page_number+1
     });
     setDataSetProductos([...value?.listado?.data]);
     setTotalCompras({
      ...value,listado:null
     });


     setTotalRows(value?.listado?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

  

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }


    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductFilterList(res);
      } catch (e) {
  
      }
    }

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }

   const onSearchProveedor = async (evt,value_search) => {

    if (value_search && value_search.length > 3) {
       try{

        const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
          search_query: value_search
        });
        setProveedorOptions(value);
        return value;
       }catch(e){
        return [];
       }

    }
}
  
    const columnsTable = [
      {
      
       key:"razon_social_prov",
       keyValue:"razon_social_prov",
       label:"Proveedor",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"nombre_producto",
        keyValue:"nombre_producto",
        label:"Producto",
        headerRender:(props)=>props.label,
        bodyRender:({info,...props})=>`${info.nombre_producto}`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },
       {
      
        key:"nombre_producto",
        keyValue:"nombre_producto",
        label:"Cantidad comprada",
        headerRender:(props)=>props.label,
        bodyRender:({info,...props})=>`${FormatPrice(info.total_compra_um)} ${info.cod_erp_unidad_compra}`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cotizacion_precio_un",
        keyValue:"cotizacion_precio_un",
        label:"Valor total compra",
        headerRender:(props)=>props.label,
        bodyRender:({info,value,...props})=>`$ ${FormatPrice( Number( (Number(info.total_compra_um) * Number( info.precio_cotizado ))?.toFixed(1) )  )} COP`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_compra",
        keyValue:"fecha_compra",
        label:"Fecha de compra",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_entrega",
        keyValue:"fecha_entrega",
        label:"Fecha de entrega",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       
 
    ];
   




    const InputFilters = [
      {
        grid:{
          xs:3,
          md:3,
          sm:3
        },
        InputComponent:DatePickerInputWithLabel,
        keyValue:"month",
        inputProps:{
          size:'small',
        },
        InputComponentProps:{
          label:"Mes a consultar",
          views:['month', 'year'],
          fullWidth:true,
          isLoading:false,
          inputFormat:"MM-YYYY",
          value:null,
          size:'small',
          //onInputChange:searchMunicipiosOrigen,
         
        }
      },
     /*  {
        grid:{
          xs:3,
          md:3,
          sm:3
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"product_select",
        InputComponentProps:{
          label:"Producto",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',

          onInputChange: searcProductoAsociado,
          options: productFilterList || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        grid:{
          xs:6,
          md:3,
          sm:6
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"proveedor_select",
        InputComponentProps:{
          label:"Proveedor",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      }, */
      ];

    return (<>
   
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={10} >

      
          <FilterForm
            buttomDist={
              {
                sx:10,
                md:5
              }
            }
            nameFilter={"Buscar resumen por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  product_select:filterSearchPagination?.producto,
            
             }
            }
            onApplyFilter={setFilterAply}
          />
       
        

        </Grid>

        <Grid spacing={1} container item sm={12} xs={12} md={12} >
            
            <Grid item sm={6} xs={6} md={4} >
              <CardResumeBuild
              title="Compras efectivas"
              label_numer={` ${totalPage.compra_efectiva}/${totalPage.cantidad_compras}`}
              />
            </Grid>
            <Grid item sm={6} xs={6} md={4} >
              <CardResumeBuild
              title="Total comprado"
              label_numer={`$ ${FormatPrice( totalPage.valor_total_comprado?.toFixed(2) )} COP`}
              />
            </Grid>
            <Grid item sm={6} xs={6} md={4} >
              <CardResumeBuild
              title="Total comision 0.3 %"
              label_numer={`$ ${FormatPrice(totalPage.valor_comision?.toFixed(2))} COP`}
             //  extraLabel="0.3 del total comprado"
              />
            </Grid>
        </Grid>

        <Grid item sm={12} xs={12} md={12} >
          <Typography variant="h6" >
              Listado de compras del mes
          </Typography>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer >
               <Table >
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cotizacion_cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}